import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M17.342 21.12c-2.064 0-3.276-1.74-3.276-4.32 0-2.592 1.212-4.32 3.276-4.32 2.076 0 3.288 1.728 3.288 4.32 0 2.58-1.212 4.32-3.288 4.32m0-1.728c.912 0 1.464-.816 1.464-2.592s-.552-2.592-1.464-2.592c-.9 0-1.452.816-1.452 2.592s.552 2.592 1.452 2.592M13.05 12.6V21h-1.764v-5.964l-1.872 1.44v-2.124l2.448-1.752z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.293 3.293a1 1 0 0 0 0 1.414L18.586 6H8a6 6 0 0 0-6 6c0 3.132 1.721 5.294 3.684 5.949a1 1 0 0 0 .632-1.898C5.28 15.706 4 14.391 4 12a4 4 0 0 1 4-4h10.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 0 0-1.414 0",
      clipRule: "evenodd"
    }
  )
);
var SvgForward10Outlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Forward10Outlined_default = SvgForward10Outlined;

export { Forward10Outlined_default as default };
